var _g, _circle, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusyDeskMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3677_22385)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 21,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 15,
    fill: "#FF0000"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9966 29.6211C40.0063 29.5103 39.973 29.4001 39.9036 29.3133L36.625 25.4961H25.375L22.096 29.3132C22.0268 29.4001 21.9936 29.5104 22.0034 29.6211H22V29.9961H22.0038C22.0024 30.0484 22.0121 30.1004 22.0323 30.1487C22.0926 30.284 22.2269 30.3712 22.375 30.3711H24.25V38.2461C24.25 38.4532 24.4179 38.6211 24.625 38.6211H25C25.2071 38.6211 25.375 38.4532 25.375 38.2461V30.3711H26.5V34.4961C26.5 34.7032 26.6679 34.8711 26.875 34.8711H27.25C27.4571 34.8711 27.625 34.7032 27.625 34.4961V30.3711H34.75V34.4961C34.75 34.7032 34.918 34.8711 35.1251 34.8711H35.5C35.7071 34.8711 35.875 34.7032 35.875 34.4961V30.3711H37V38.2461C37 38.4532 37.1679 38.6211 37.375 38.6211H37.75C37.9571 38.6211 38.125 38.4532 38.125 38.2461V30.3711H39.625C39.7732 30.3712 39.9075 30.2841 39.9678 30.1487C39.9879 30.1004 39.9976 30.0484 39.9963 29.9961H40V29.6211H39.9966Z",
    fill: "#6F0606"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3677_22385",
    x: 0,
    y: 0,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3677_22385"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3677_22385",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusyDeskMarker);
export default __webpack_public_path__ + "static/media/busy-desk-marker.891f1e1ba180a88e133279a354767d72.svg";
export { ForwardRef as ReactComponent };